<template>
  <div class="accordion mt-2 mb-5" id="accordionExample">
    <div v-for="(section, index) in sections" :key="index" class="card">
      <div class="card-header" :id="'heading' + index">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-left"
            type="button"
            data-toggle="collapse"
            :data-target="'#collapse' + index"
            aria-expanded="true"
            :aria-controls="'collapse' + index"
            style="display: flex; justify-content: space-between;"
          >
            <span class="titulo"><p class="m-0">{{ section.titulo }} <span v-if="section.pieTitulo" class="pie-titulo">{{section.pieTitulo}}</span></p></span>
            <span class="descargar"><i class="bx bx-chevron-down icono-down"></i></span>
          </button>
        </h2>
        <div
          :id="'collapse' + index"
          class="collapse"
          :class="{ show: !collapse }"
          :aria-labelledby="'heading' + index"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            <ul>
              <li class="container" v-for="(contenido, i) in section.contenido" :key="i">
                <div class="item-container row">
                  <p v-if="contenido.url_pdf=='' && contenido.url_word=='' &&  contenido.url_excel=='' && contenido.url_comprimido==''" class="font-weight-bold item-name col-md-9">{{ contenido.titulo }}</p>
                  <p v-else class="item-name col-md-9">{{ contenido.titulo }}<span v-if="contenido.pieTitulo" class="pie-titulo">{{contenido.pieTitulo}}</span></p>
                  
                  <div class="icons col-md-3">
                    <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank" class="icon-pdf">
                      <i class="fas fa-file-pdf"></i>
                    </a>
                    <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank" class="icon-word">
                      <i class="fas fa-file-word"></i>
                    </a>
                    <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank" class="icon-excel">
                      <i class="fas fa-file-excel"></i>
                    </a>
                    <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank" class="icon-rar">
                      <i class="fas fa-file-archive"></i>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      // Estructura: [{ title: 'Title', items: [{ name: 'Item Name', path: 'item-path', pdf: 'pdf-path', word: 'word-path', excel: 'excel-path', rar: 'rar-path' }, ...] }, ...]
    },
    urlServe: {
      type: String,
      default: ''
    },
    collapse:{
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.accordion .card .card-header {
    border-radius: 0!important;
    margin-bottom: -1px!important;
    background-color: #fff!important;
}
.card-header:first-child {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0!important;
}
.card-header {
    padding: .75rem 1.25rem!important;
    margin-bottom: 0!important;
    background-color: rgba(0, 0, 0, .03)!important;
    border-bottom: 1px solid rgba(0, 0, 0, .125)!important;
}
.card-header span{
    color:#621132;
    transition: ease all .1s;
    font-weight: 400;
}
.card-header span:hover{
    transform: scale(1.04);
    border: none !important; 
}
.card-body li {
    list-style-type: none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
    transition: ease all .1s;
    /* display: flex; */
    justify-content: space-between;
    align-items: center; 
}
.card-body li:hover{
     transform: scale(1.01);
}
.card-body ul li a.item-name {
    color: #000!important;
    text-decoration: none;
    cursor: pointer;
    flex-grow: 1; 
}
.item-name .pie-titulo,
.titulo .pie-titulo{
  font-size: .8rem;
  font-style: italic;
  color:#a1a1a1;
  margin-left: 10px;
}
.icons {
    display: flex;
    gap: 10px;
    font-size: 1.5rem;
}
.icons a {
    color: #000;
    transition: color 0.2s;
}
.icons a:hover {
    color: #007bff; 
}
.icon-pdf{
    color: #e74c3c!important; 
}
.icon-word {
    color: #007bff!important;
}
.icon-excel {
    color: #28a745!important;
}
.icon-rar {
    color: #f39c12!important;
}
</style>
